<!-- <p>bt-color-popover works!</p> -->

<!-- <nz-color-block nzSize="large"></nz-color-block> -->

<a
  href="#"
  [class]="'cp-button bt-size-' + size"

  nz-button
  nz-popover
  [nzPopoverContent]="contentTemplate">
  <!--
  nzPopoverTrigger="click" -->

  @for (hex of defaultColors; track hex) {
    <span
      class="cp-color"
      [style.backgroundColor]="hex"
    ></span>
  }

</a>



<ng-template #contentTemplate>
  <div class="colors">

    <div
      class="box-color blank"
      [class.selected]="color == ''"
      (click)="onClick('')"
    ></div>
    @for (hex of presets; track hex) {
      <div
        class="box-color"
        [class.selected]="color == hex"
        [style.backgroundColor]="hex"
        (click)="onClick(hex)"
      ></div>
    }
  </div>
  <div class="pull-clear"></div>
</ng-template>
